// file created at 2020-3-4
// Auto-generated files InteractionRecord.ts

import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import Palette from '@/interfaces/Palette';
import Datum from '@/interfaces/Datum';
import { InteractionLabelsDict } from '@/interfaces/Etc';

@Component({})
export default class InteractionRecord extends Vue {

  @Prop({ required: true })
  public componentNodes!: Array<d3.HierarchyPointNode<Datum>>;
  public initialComponentNodes: Palette = []; // record용
  public interactionRecords: Array<{
    sourceNode: d3.HierarchyPointNode<Datum>;
    targetNodes: Array<d3.HierarchyPointNode<Datum>>;
    interactionLabel: string | null;
  }> = [];

  public saveAlter(o: {
    node: d3.HierarchyPointNode<Datum>,
    isForEnglishPaper: boolean,
    interactionLabelsDict: InteractionLabelsDict
  }) {
    const lastInteractionRecord = this.interactionRecords[this.interactionRecords.length - 1];
    lastInteractionRecord.interactionLabel = o.isForEnglishPaper ?
      o.interactionLabelsDict.english.alter : o.interactionLabelsDict.korean.alter;
    lastInteractionRecord.targetNodes.push(o.node);
    this.initialComponentNodes = _.filter(
      this.initialComponentNodes, componentNode => {
        return lastInteractionRecord.sourceNode.data.id !== componentNode.data.id;
      }
    );
  }

  public saveSplit(o: {
    node: d3.HierarchyPointNode<Datum>,
    isForEnglishPaper: boolean,
    interactionLabelsDict: InteractionLabelsDict
  }) {
    console.log('saveSplit', o);

    const lastInteractionRecord = this.interactionRecords[this.interactionRecords.length - 1];
    console.log('lastInteractionRecord', lastInteractionRecord);
    lastInteractionRecord.interactionLabel = o.isForEnglishPaper ?
      o.interactionLabelsDict.english.split : o.interactionLabelsDict.korean.split;
    console.log('lastInteractionRecord.interactionLabel', lastInteractionRecord.interactionLabel);
    lastInteractionRecord.targetNodes = [
      o.node.children![0],
      o.node.children![1]
    ];
    this.initialComponentNodes = _.filter(
      this.initialComponentNodes, componentNode => {
        return lastInteractionRecord.sourceNode.data.id !== componentNode.data.id;
      }
    );
  }

  public saveMerge(o: {
    node: d3.HierarchyPointNode<Datum>,
    isForEnglishPaper: boolean,
    interactionLabelsDict: InteractionLabelsDict
  }) {
    const lastInteractionRecord = this.interactionRecords[this.interactionRecords.length - 1];
    lastInteractionRecord.interactionLabel = o.isForEnglishPaper ?
      o.interactionLabelsDict.english.merge : o.interactionLabelsDict.korean.merge;
    lastInteractionRecord.targetNodes.push(o.node.parent!);
    this.initialComponentNodes = _.filter(
      this.initialComponentNodes, componentNode => {
        return lastInteractionRecord.sourceNode.data.id !== componentNode.data.id;
      }
    );
  }

  public saveRevert(o: {
    node: d3.HierarchyPointNode<Datum>,
    isForEnglishPaper: boolean,
    interactionLabelsDict: InteractionLabelsDict
  }) {
    const lastInteractionRecord = this.interactionRecords[this.interactionRecords.length - 1];
    lastInteractionRecord.interactionLabel = o.isForEnglishPaper ?
      o.interactionLabelsDict.english.revert : o.interactionLabelsDict.korean.revert;
    lastInteractionRecord.targetNodes.push(o.node);
    this.initialComponentNodes = _.filter(
      this.initialComponentNodes, componentNode => {
        return lastInteractionRecord.sourceNode.data.id !== componentNode.data.id;
      }
    );
  }

  private isComponent(node: d3.HierarchyPointNode<Datum>): boolean {
    return this.componentNodes.includes(node);
  }

  private mounted() {
    //
  }
}
